
type FormFields<T> = Array<[T, string]>

export interface AppointmentFormValues {
  documentNumber?: string
  nfcKey?: string
  firstName?: string
  lastName?: string
  email?: string
  birthDate?: string
  nationality?: string
  address?: string
  age?: number
  isInterviewed?: boolean
  isNoFee?: boolean
  isNegativeBalanceAllowed?: boolean
  referredBy?: string
}

export type AppointmentFormField = keyof AppointmentFormValues

export const appointmentFormTitles: Record<AppointmentFormField, string> = {
  documentNumber: 'Identification Document Number',
  nfcKey: 'NFC Key number',
  firstName: 'First Name',
  lastName: 'Last Name',
  email: 'Email address',
  birthDate: 'Date of birth',
  nationality: 'Nationality',
  address: 'Address',
  age: 'Age',
  isInterviewed: 'Is member interviewed',
  isNoFee: 'No Membership Fee',
  isNegativeBalanceAllowed: 'Negative Balance Allowed',
  referredBy: 'Referred By',
}

export const appointmentFormFields: FormFields<AppointmentFormField> = Object.entries(
  appointmentFormTitles
) as FormFields<AppointmentFormField>

export const appointmentFormInitialData: AppointmentFormValues = {
  documentNumber: '',
  nfcKey: '',
  firstName: '',
  lastName: '',
  email: '',
  birthDate: '',
  nationality: '',
  address: '',
  age: 0,
  isInterviewed: false,
  isNoFee: false,
  isNegativeBalanceAllowed: false,
  referredBy: '',
}
